import JsCookies from 'js-cookie'
import * as v from 'valibot'

import {
  CookieCategory,
  CookieConsent,
  cookieConsentSchema,
} from '../../types/cookie-consent.js'

import { TribeEmitter, TribeEmitterEvent } from './TribeEmitter.js'

const COOKIE_CONSENT_KEY = 'c_cookie_consent'

const YEAR_IN_MS = 12 * 30 * 24 * 60 * 60 * 1000

export class CookieManager {
  private cmpProviderEnabled: boolean

  constructor(cmpProviderEnabled: boolean) {
    this.cmpProviderEnabled = cmpProviderEnabled
  }

  getCookieConsent(): CookieConsent | undefined {
    const cookieValue = JsCookies.get(COOKIE_CONSENT_KEY)
    const schema = v.pipe(v.string(), v.parseJson(), cookieConsentSchema)

    const result = v.safeParse(schema, cookieValue)
    if (!result.success) {
      return undefined
    }

    return result.output
  }

  isConsentGranted(params: { category: CookieCategory; name?: string }) {
    if (!this.cmpProviderEnabled) {
      return true
    }

    const cookieConsent = this.getCookieConsent()
    if (!cookieConsent) {
      return false
    }

    const permission = cookieConsent.permissions.find(
      permission => permission.category === params.category,
    )

    if (!permission) {
      return false
    }

    return !permission.excluded?.includes(params.name)
  }

  setCookieConsent(cookieConsent: CookieConsent) {
    JsCookies.set(COOKIE_CONSENT_KEY, JSON.stringify(cookieConsent), {
      path: '/',
      expires: new Date(Date.now() + YEAR_IN_MS),
    })

    TribeEmitter.emit(TribeEmitterEvent.ON_COOKIE_CONSENT_CHANGE, {
      cookieConsent,
    })
  }
}
